import { type TInsurancesResponse } from '@/types/insuranceMapper';
import {
  type GetFilteredInsurancesFilters,
  type TInsuranceDetailed
} from '@/types/insuranseServer';
import { type TNewInsuranceDto } from '@/types/newInsurance';
import { type TFile } from '@/types/request';

import { ApiConnector } from '../api.connector';

class InsuranceApi extends ApiConnector {
  getFilteredInsurances(
    filters: GetFilteredInsurancesFilters
  ): Promise<TInsurancesResponse> {
    return this.call({
      path: 'insurances/filters/getFilteredInsurances',
      method: 'post',
      body: filters
    });
  }

  getOneInsurance(id: string): Promise<TInsuranceDetailed> {
    return this.call({ path: `insurances/findByInsuranceId/${id}` });
  }

  requestCreateOtpInsurance(data: {
    iin: string;
    last_name: string;
    first_name: string;
    middle_name: string;
    clientPhone: string;
  }): Promise<{ request_uuid: string }> {
    return this.call({
      path: 'insurances/createOTP',
      body: data,
      method: 'post'
    });
  }

  validateOTPInsurance(data: {
    uuid: string;
    otp: string;
  }): Promise<{ otpCode: string; result: boolean }> {
    return this.call({
      path: 'insurances/validateOTP',
      body: data,
      method: 'post'
    });
  }

  createInsuranceOrder(data: TNewInsuranceDto): Promise<TInsuranceDetailed> {
    return this.call({
      path: `insurances/updateInsurance/${data.uuid}`,
      method: 'patch',
      body: data
    });
  }

  restartInsuranceOrder(id: string) {
    return this.call({
      path: `insurances/restartInsurance/${id}`,
      method: 'post'
    });
  }

  findInsuranceFiles(id: string): Promise<TFile[]> {
    return this.call({ path: `files/${id}/findByInsuranceId` });
  }
}

export const insuranceApi = new InsuranceApi();
